// schemeChoice.options.ts

interface IAvailableOption {
    key: string;
    input_type?: string;
    default?: string;
    options?: any[];
    [k: string]: any;
}

export type AvailableOptionsMap = Record<string, IAvailableOption>;

export function splitOptions(allOptions?: AvailableOptionsMap) {
    const mappedAllObjects: Record<string, IAvailableOption> = {};
    let hazardousActivityOption: IAvailableOption | undefined;

    if (allOptions) {
        Object.entries(allOptions)
            .sort(([, a], [, b]) => a.key.localeCompare(b.key))
            .forEach(([fieldKey, option]) => {
                if (option.key !== 'hazardous_activities') {
                    mappedAllObjects[fieldKey] = option;
                }
            });

        hazardousActivityOption = Object.values(allOptions).find(
            (option) => option.key === 'hazardous_activities',
        );
    }

    const hazardousOptions =
        hazardousActivityOption && Array.isArray(hazardousActivityOption.options)
            ? hazardousActivityOption.options
            : [];

    return { mappedAllObjects, hazardousActivityOption, hazardousOptions };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/schemeChoice.options.ts